import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getSurveyListReportReq,
  getSurveyListReportResClear,
} from "../../redux/assignCourse/actions";
import { SessionKeys } from "../../utils/AppUtils";
import Select from "react-select";

const ChooseSurvey = (props) => {
  const {
    selectedSurveyList,
    setSelectedSurveyList,

    isMobile,
  } = props;

  const dispatch = useDispatch();

  const providerSearchRes = useSelector(
    (state) => state.assignCourse.surveyListRes
  );

  const [searchInput, setSearchInput] = useState("");
  const [providerList, setProviderList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);

  const [errorMsg, setErrorMsg] = useState("");
  const [providerOptList, setProviderOptList] = useState([]);
  const [defaultValue, setDefaultValue] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [apiCalled, setApiCalled] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setApiCalled(true);
    searchProvider();
  }, []);

  useEffect(() => {
    console.log("dropdown options survey--", providerOptList);
  }, [providerOptList]);

  useEffect(() => {
    console.log("sel---", selectedSurveyList);
    setSelectedCount(selectedSurveyList?.length);
    const newDefaultValue = selectedSurveyList?.map((provider) => ({
      value: provider.id,
      label: provider.title,
    }));

    setDefaultValue(newDefaultValue);
  }, [selectedSurveyList]);

  useEffect(() => {
    if (searchInput !== undefined && searchInput.length > 2) searchProvider();
    else setErrorMsg("");
  }, [searchInput]);

  const searchProvider = () => {
    dispatch(
      getSurveyListReportReq({
        module: "lpFilterList",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          search: searchInput,
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(providerSearchRes) && apiCalled) {
      console.log("survey filter res: ", providerSearchRes);
      if (providerSearchRes?.status === "success") {
        const providerArr = providerSearchRes?.payload?.payload;
        setProviderList(providerArr);
        setProviderOptList(
          _.map(providerArr, (provider) => {
            return {
              value: provider.id,
              label: provider.title,
            };
          })
        );
        if (
          !_.isEmpty(searchInput) &&
          searchInput?.length > 2 &&
          providerSearchRes?.payload?.payload?.length === 0
        ) {
          setErrorMsg("No result found for your search.");
        } else {
          setErrorMsg("");
        }
      }
      setIsLoading(false);
    }
  }, [providerSearchRes]);

  return (
    <>
      <div className="chooseteamate">
        <h4>Choose Survey</h4>
        <div className="input-lear position-relative d-flex">
          <label for="teamsearch" className="input__label_learning">
            Search
          </label>

          <Select
            isMulti
            name="colors"
            className="basic-multi-select w-100 multi-label-select"
            classNamePrefix="xsel"
            options={providerOptList}
            value={defaultValue}
            isLoading={isLoading}
            onChange={(e) => {
              console.log(e);
              if (!_.isEmpty(e)) {
                setErrorMsg("");
                let data = [];
                for (let provider of providerList) {
                  for (let sO of e) {
                    if (sO.value === provider.id) {
                      data.push(provider);
                    }
                  }
                }
                setSelectedSurveyList(data);
              } else {
                setSelectedSurveyList([]);
              }
            }}
          />
        </div>
        <p className="error-msg">{errorMsg}</p>
      </div>
    </>
  );
};

export default ChooseSurvey;
